import cx from 'classnames';
import {useMemo} from 'react';

import {Icon, IconColor} from 'components';

type Props = {
    type?: 'danger' | 'warning' | 'default';
    children: React.ReactElement | React.ReactElement[] | string;
    className?: string;
}

export const Alert: React.FC<Props> = ({type = 'default', className, children}) => {
    const iconColor: IconColor = useMemo(() => {
        if (type === 'danger') {
            return 'alternative';
        } else {
            return 'default';
        }
    }, [type]);

    return (
        <div className={cx('tw-flex tw-py-2', className, {
            'tw-bg-default': type === 'default',
            'tw-bg-warning-light': type === 'warning',
            'tw-bg-alert-light tw-text-alternative': type === 'danger'
        })}
        >
            <div className='tw-min-w-12 tw-flex-center'>
                <Icon name='alert-triangle' color={iconColor} />
            </div>
            <div className='tw-pr-4 tw-flex tw-flex-col tw-justify-center'>{children}</div>
        </div>
    );
};